import { useEffect, type ReactNode } from 'react'

import { useAuth } from '@/lib/config/auth-provider'
import { useTheme } from '@/lib/theme-provider'

const PYLON_APP_ID = '2ac65c1b-9088-40c2-a595-b3f68f3a5b68'

function callPylon(command: string, ...args: unknown[]) {
  const pylon = (window as any).Pylon
  if (typeof pylon === 'function') pylon(command, ...args)
}

interface PylonProviderProps {
  children: ReactNode
}

/**
 * Identifies the logged-in user to Pylon (for popup surveys) and syncs
 * the widget theme. The chat bubble is always hidden — support forms
 * are opened as external portal URLs from the sidebar dropdown.
 */
export function PylonProvider({ children }: PylonProviderProps) {
  const { user, isAuthenticated } = useAuth()
  const { resolvedTheme } = useTheme()

  const isActive = isAuthenticated && !!user

  useEffect(() => {
    if (isActive) {
      ;(window as any).pylon = {
        chat_settings: {
          app_id: PYLON_APP_ID,
          email: user.email,
          name: user.name ?? user.email,
        },
      }
    } else {
      ;(window as any).pylon = undefined
    }
  }, [isActive, user?.email, user?.name])

  useEffect(() => {
    callPylon('setTheme', resolvedTheme)
  }, [resolvedTheme])

  useEffect(() => {
    callPylon('hideChatBubble')
  }, [isActive])

  return <>{children}</>
}
